import { Alert, Box, List, ListItem, Stack, Typography } from "@mui/material"
import { DialogBox } from "lib/@components/dialogBox"
import Iconify from "minimals-template/components/Iconify"

export function SentToLegacyDialog({
    title = "Updates sent to Legacy",
    intro = "You pushed all changes to Legacy. This means the work package is locked and you can't make any further edits here.",
    summary = "This work package is now locked",
}) {
    return (
        <DialogBox
            title={
                <Box display={"flex"} alignItems={"center"} gap={"20px"}>
                    <Iconify icon={"mdi:tick-circle-outline"} />
                    <Typography variant="h5">{title}</Typography>
                </Box>
            }
            value={true}
            data-cy="sent-to-legacy-dialog"
            okCaption={"Ok"}
        >
            <Typography mt={2}>{intro}</Typography>
            <Alert
                severity="info"
                icon={<Iconify icon={"material-symbols:lock"} />}
                title=""
                sx={{
                    alignItems: "center",
                    "& .MuiAlert-icon": { display: "flex", alignItems: "center" },
                }}
            >
                <Stack>
                    <Typography variant="subtitle1">{summary}</Typography>
                    <List
                        sx={{
                            listStyleType: "disc",
                            listStylePosition: "inside",
                            "& .MuiListItem-root": { display: "list-item", p: 0 },
                        }}
                    >
                        <ListItem>You can no longer add or edit groups</ListItem>
                        <ListItem>You can still view the changes and access logs</ListItem>
                    </List>
                </Stack>
            </Alert>
        </DialogBox>
    )
}
